const init = () => {
  const globalData = require('./globalData');
  const eventBus = require('./eventBus');
  const $win = $(window);
  $win.on('resize', () => {
    const [width, height] = [$win.width(), $win.height()];
    globalData.set('windowSize', {width, height});
    eventBus.trigger('resize');
  });
};

/*
*   显示指定窗口
*   element：   要显示的元素
*   msg：   显示的消息
*   delay：   delay秒后，窗口关闭
*/
const displayElementView = function displayTipView (element, msg, color = '#ed1c00', delay = 2) {
  element.html(msg);
  element.css('visibility','visible');
  element.css('color',color);
  setTimeout(function (){
      element.css('visibility','hidden');
      element.html('');
  }, delay * 1000);
};

function showToast (strMsg, duration = 2000){
  const nLen = $("body div.zw-toast-pop").length;
  if (nLen == 0){
    const htmlText = '<div class="zw-toast-pop">' +
                      '<div class="zw-toast-inner">' + 
                        '<div class="zw-toast-inner-text"></div>' +
                      '</div>' +
                    '</div>';
    $("body").append(htmlText);
    $('body div.zw-toast-pop').on('click', function() {
      const toastElement = $('body div.zw-toast-pop');
      toastElement.remove();
    });
  }
  $("body div.zw-toast-pop .zw-toast-inner .zw-toast-inner-text").text(strMsg); 
  fadeOutToast(duration);
}
function fadeOutToast(duration = 2000) {
  const toastElement = $('body div.zw-toast-pop');
  toastElement.fadeIn();    
  setTimeout(function() {
    toastElement.fadeOut();    
  }, duration);
}

module.exports = {init, displayElementView, showToast};